
// import NProgress from 'nprogress'
// import store from '@/store'
import $ from 'jquery'
import UploadResult from '@/views/analyse/modal-upload-resultat';
import VoirResultat from '@/views/analyse/visualiser-resultat';
import DateFilter from '@/components/date-filter';
import ManageResultatTDR from '@/views/analyse/manage-resultat-tdr'
import store_analyse from '@/store/mods/analyses/analyse'

import { showToast } from '@/utils/notifications'

export default {
    name: 'others-registre',
    components: { 
        UploadResult, VoirResultat, DateFilter,
        ManageResultatTDR 
    },
    props: [],
    data() {
        return {
            loading: false,
            demande: null,

            is_loading: true,
            is_empty: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_month: false, 

            liste_patient_analyse_to_fill: {},
            evolution_id: 0,
            selected_analyse: {},
            toggler: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                etat_resultat: 0,
                analyse_id: this.$route.params.analyse_id
            }
            this.current_date_filter = data
            this.is_month = true
            this.getListePatientEnSallePrelevement(data)
        },
    },

    computed: {
        analyse() {
            return this.$store.getters['analyse']
        },

        tsl_filter_date() {
            return this.$store.getters["tsl_filter_date"]
        },

        modeles_analyses() {
          return this.$store.getters["modeles_analyses"];
        },

        patient_meta_data() {
            return this.$store.getters["patientMetaData"];
        },

        pending_filter_date() {
            return this.$store.getters["pending_filter_date"];
        },
    },

    created() { },
    
    async mounted() {
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        this.current_date_filter = this.tsl_filter_date
        this.tsl_filter_date.analyse_id = this.$route.params.analyse_id
        
        this.getListePatientEnSallePrelevement(this.tsl_filter_date)

        await this.$store.dispatch('fetchModelesAnalyses', {analyse_id: this.$route.params.analyse_id, status: 'active'});
    },
    methods: {
        refreshSallePrelevement() {
            this.getListePatientEnSallePrelevement(this.current_date_filter)
        },

        getListePatientEnSallePrelevement(data) {
            this.liste_patient_analyse_to_fill = {}
            this.is_loading = true

            store_analyse.getListePatientAnalyseToFill(data).then((response) => {
                this.liste_patient_analyse_to_fill = response
                if (this.liste_patient_analyse_to_fill.l_patient.length > 0) {
                    this.is_empty = false 
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                etat_resultat: 0,
                analyse_id: this.$route.params.analyse_id
            }
            this.current_date_filter = data
            this.filter_date = ""
            this.is_month = false

            this.getListePatientEnSallePrelevement(data)
        },

        refreshListeAttente() {
            this.getListePatientEnSallePrelevement(this.current_date_filter)
        },

        selectAnalyseUpload(demande) {
            this.demande = demande

            setTimeout(() => {
                $('#upload-modal').modal('show')
            }, 200);
        },

        updateCommentairesResult(demande) {
            let data = { commentaires: demande.commentaires }

            this.$store.dispatch('updateResultatCommentaires', { id: demande.id, data: data })
        },

        saveResults() {
            this.loading = true

            setTimeout(() => {
                this.loading = false
                this.successMessage()
                this.$router.push({ path: '/dashboard' });
            }, 1000);
        },

        successMessage: function () {
            const message = 'Les résultats ont été enregistrés';
            showToast(message, 'success', 'toasted-primary', {position: 'top-center'})
        },

        selectModeleAnalyse(modele) {
            this.$store.dispatch('setModeleAnalyse', modele)
            this.$store.dispatch("setResultatsAnalyse", null);

            this.$bvModal.hide('models-list-modal')

            const patientId = this.patient_meta_data.patient_id;

            this.$router.push({ path: `/analyses/${this.$route.params.analyse_id}/patients/${patientId}/resultats` })
        },

        onModalOpen(data) {
            console.log(">>> ", data);
            if (this.liste_patient_analyse_to_fill.analyse == 'TDR Malaria') {
                this.toggler = (this.toggler == 0)?1:0

                const d = {
                    nom: this.liste_patient_analyse_to_fill.analyse,
                    resultat_tdr: '',
                    demande_id: data.id
                }
                this.selected_analyse = d;

                $('#manage-tdr-'+this.evolution_id).modal('show')
            } else {
                if (!this.is_modele_analyse) {
                    this.selectAnalyseUpload(data)
                } else {
                    this.$store.dispatch("setResultsMode", "add");
                    const patient_meta_data = {
                        patient_id: data.patient_id,
                        patient_fullname: data.patient,
                        patient_age: data.age,
                        patient_gender: data.sexe,
                        patient_phone: data.telephone,
                        doctor_fullname: data.medecin_demandeur,
                        clinical_inquiries: data.renseignement_clinique,
                        methodology_applied: data.technique_utilisee,
                        bulletin_analyse_id: data.bulletin_id,
                    }

                    this.$store.dispatch('setPatientMetaData', patient_meta_data)

                    if(this.modeles_analyses.length === 0) {
                        const message = 'Aucun modèle d\'analyse disponible pour cette analyse!';
                        showToast(message, 'error', 'toasted-primary', {position: 'top-center'})
                    }else if(this.modeles_analyses.length === 1) {
                        this.selectModeleAnalyse(this.modeles_analyses[0]);
                        
                    }else{
                        this.$refs['models-modal'].show()
                    }
                }
            }
        }
    }
}


